import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import 'shared/styles/table.style.less';
import {Button} from 'antd';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import LocationTable from './LocationTable';
import {LocationContext} from './LocationContext';
import {IoReload} from 'react-icons/all';

const LocationList = () => {
  const intl = useIntl();
  const locationContext = useContext(LocationContext);

  const {setReloading} = locationContext;

  return (
    <>
      <AppPageMetadata title={intl.messages['location.list']} />
      <AppsContainer
        title={intl.messages['location.list']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view' />
            <div className='customer-header-right'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoReload />}
                onClick={() => setReloading(true)}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <LocationTable />
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default LocationList;
